<script>
  import {
    geos,
    geos_class,
    geos_map,
    group,
    live,
    menu,
    nicks_list,
    poli,
    route_list_d,
    travel_crtl,
    travels,
    drivers,
    unit_config,
    unit_types,
    units_list,
    cc_monitor,
    torre_unit_navigation,
  } from "./stores.js";
  import { onMount, onDestroy } from "svelte";
  import {
    EXT_OMNI_GEOC_URL,
    fetchJsonSafe,
  } from "./external-service-urls.js";
  import { getKm, searchGeofence } from "./geofence-search.js";

  const LIST_REFRESH_MS = 2000;
  const GEOCODE_CONCURRENCY = 4;
  const TORRE_GEOCODE_CACHE_KEY = "__vector_torre_geocode_cache__";
  const UNIT_FILTER_KEY = "filtro_torre";
  const SCORE_CONFIG_KEY = "torre_score_config";
  const QUICK_FILTERS_KEY = "torre_quick_filters";
  const SEARCH_FILTER_KEY = "torre_search_filter";
  const SILENCED_UNITS_KEY = "torre_silenced_units";
  const SAVED_VIEWS_KEY = "torre_saved_views";
  const ACTIVE_VIEW_KEY = "torre_active_view";
  const GEOFENCE_DWELL_KEY = "torre_geofence_dwell";
  const quick_filter_options = [
    { id: "anomaly", label: "Anomalías" },
    { id: "no_report", label: "Sin reporte" },
    { id: "high_speed", label: "Alta velocidad" },
    { id: "gps_bad", label: "GPS malo" },
    { id: "signal_bad", label: "Señal mala" },
    { id: "geofence", label: "En geocerca" },
    { id: "ignition_on", label: "Ignición ON" },
    { id: "priority", label: "Prioridad alta" },
    { id: "hide_silenced", label: "Ocultar revisadas" },
  ];
  const view_profiles = [
    {
      name: "Normal",
      filters: [],
      search: "",
    },
    {
      name: "Noche",
      filters: ["ignition_on", "no_report", "signal_bad"],
      search: "",
    },
    {
      name: "Seguridad",
      filters: ["priority", "high_speed", "geofence"],
      search: "",
    },
    {
      name: "Carretera",
      filters: ["high_speed", "gps_bad", "signal_bad"],
      search: "",
    },
    {
      name: "Solo anomalías",
      filters: ["priority"],
      search: "",
    },
  ];
  const column_options = [
    { id: "priority", label: "Prioridad" },
    { id: "speed", label: "Velocidad" },
    { id: "ignition", label: "Ignición" },
    { id: "report_time", label: "Último reporte" },
    { id: "report_age", label: "Sin reportar" },
    { id: "gps", label: "GPS/HDOP" },
    { id: "signal", label: "Señal/Red" },
    { id: "geofence", label: "Geocerca/Zona" },
    { id: "travel", label: "Viaje" },
  ];
  const default_score_config = {
    weight_any_change: 10,
    weight_ignition_change: 20,
    weight_movement_start: 20,
    weight_movement_stop: 20,
    weight_high_speed: 20,
    high_speed_threshold: 80,
    weight_no_report: 30,
    no_report_minutes_on: 15,
    no_report_minutes_off: 60,
    score_decay: 1,
    score_max: 50,
  };

  let map = 0;
  let marquee;
  let control;
  let lista_;
  let cancel_initial_lista = null;

  var table_pos_ = [];
  let last_pos_geo = {};
  let live_st = {};
  let loop_msg = {};
  let points_pos = {};
  let priority_reasons = {};
  let travel_by_modid = Object.create(null);
  let table_pos_p = [];
  let filtered_table_pos_ = [];
  let torre_summary = create_empty_summary();
  let expanded_modid = null;
  let action_feedback = {};
  let action_feedback_timer = null;
  let geofence_dwell = {};
  let silenced_units = {};
  let saved_views = [];
  let active_view_name = "";
  let geocode_queue = [];
  let geocode_queue_index = Object.create(null);
  let geocode_inflight_index = Object.create(null);
  let geocode_inflight_count = 0;
  let geocode_pump_timer = null;

  let storage_scope = "";
  let storage_hydrated = false;
  let table_pos_f = [];
  let table_pos_filter_set = new Set(table_pos_f);
  let filtro_modal = false;
  let score_modal = false;
  let units_list_p = [];
  let score_config = { ...default_score_config };
  let score_config_form = { ...score_config };
  let search_filter = "";
  let quick_filters = [];
  let quick_filter_set = new Set(quick_filters);

  onMount(() => {
    function initMap() {
      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 24.458489, lng: -102.217231 },
        zoom: 5,
      });
    }
    //initMap();
    cancel_initial_lista = schedule_after_paint(() => {
      lista();
      lista_ = setInterval(lista, LIST_REFRESH_MS);
    });

    marquee = new dynamicMarquee.Marquee(document.getElementById("marquee"), {
      rate: -100,
      upDown: false,
      startOnScreen: false,
    });
    control = dynamicMarquee.loop(marquee, [() => " Torre de control | "]);
  });

  onDestroy(() => {
    clearInterval(lista_);
    if (cancel_initial_lista) {
      cancel_initial_lista();
      cancel_initial_lista = null;
    }
    if (geocode_pump_timer != null) {
      clearTimeout(geocode_pump_timer);
      geocode_pump_timer = null;
    }
    if (action_feedback_timer != null) {
      clearTimeout(action_feedback_timer);
      action_feedback_timer = null;
    }
    geocode_queue = [];
    geocode_queue_index = Object.create(null);
    if (control != null) {
      control.update([]);
    }
    control = null;
    marquee = null;
  });

  function get_scoped_storage_key(key, group_name = storage_scope) {
    return key + ":" + encodeURIComponent(String(group_name || ""));
  }

  function get_torre_geocode_cache(group_name) {
    if (typeof window === "undefined") {
      return {};
    }
    let cache_key = get_scoped_storage_key(
      TORRE_GEOCODE_CACHE_KEY,
      group_name
    );
    let cache = window[cache_key];
    if (!cache || typeof cache !== "object") {
      cache = {};
      window[cache_key] = cache;
    }
    return cache;
  }

  function schedule_after_paint(callback) {
    let frame_id = null;
    let timeout_id = null;
    if (
      typeof window !== "undefined" &&
      typeof window.requestAnimationFrame === "function"
    ) {
      frame_id = window.requestAnimationFrame(() => {
        frame_id = null;
        timeout_id = window.setTimeout(() => {
          timeout_id = null;
          callback();
        }, 0);
      });
    } else {
      timeout_id = setTimeout(() => {
        timeout_id = null;
        callback();
      }, 0);
    }
    return () => {
      if (
        frame_id != null &&
        typeof window !== "undefined" &&
        typeof window.cancelAnimationFrame === "function"
      ) {
        window.cancelAnimationFrame(frame_id);
      }
      if (timeout_id != null) {
        clearTimeout(timeout_id);
      }
    };
  }

  function read_int(value, fallback, min = 0) {
    let number = parseInt(value, 10);
    if (isNaN(number)) return fallback;
    if (number < min) return min;
    return number;
  }

  function normalize_score_config(config) {
    config = config || {};
    return {
      weight_any_change: read_int(
        config.weight_any_change,
        default_score_config.weight_any_change
      ),
      weight_ignition_change: read_int(
        config.weight_ignition_change,
        default_score_config.weight_ignition_change
      ),
      weight_movement_start: read_int(
        config.weight_movement_start,
        default_score_config.weight_movement_start
      ),
      weight_movement_stop: read_int(
        config.weight_movement_stop,
        default_score_config.weight_movement_stop
      ),
      weight_high_speed: read_int(
        config.weight_high_speed,
        default_score_config.weight_high_speed
      ),
      high_speed_threshold: read_int(
        config.high_speed_threshold,
        default_score_config.high_speed_threshold
      ),
      weight_no_report: read_int(
        config.weight_no_report,
        default_score_config.weight_no_report
      ),
      no_report_minutes_on: read_int(
        config.no_report_minutes_on,
        default_score_config.no_report_minutes_on,
        1
      ),
      no_report_minutes_off: read_int(
        config.no_report_minutes_off,
        default_score_config.no_report_minutes_off,
        1
      ),
      score_decay: read_int(config.score_decay, default_score_config.score_decay),
      score_max: read_int(config.score_max, default_score_config.score_max, 1),
    };
  }

  function load_score_config(storage_key) {
    let config_raw = window.localStorage.getItem(storage_key);
    if (!config_raw) {
      return { ...default_score_config };
    }
    try {
      let config_saved = JSON.parse(config_raw);
      return normalize_score_config(config_saved);
    } catch (error) {
      return { ...default_score_config };
    }
  }

  function load_json_storage(key, fallback) {
    let raw = window.localStorage.getItem(key);
    if (!raw) {
      return fallback;
    }
    try {
      let parsed = JSON.parse(raw);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      return fallback;
    }
  }

  function load_quick_filters(storage_key) {
    let filters_raw = window.localStorage.getItem(storage_key);
    if (!filters_raw) {
      return [];
    }
    try {
      let filters_saved = JSON.parse(filters_raw);
      return Array.isArray(filters_saved) ? filters_saved : [];
    } catch (error) {
      return [];
    }
  }

  function hydrate_torre_storage(group_name) {
    let next_scope = String(group_name || "").trim();
    if (!next_scope) {
      return;
    }

    storage_hydrated = false;
    storage_scope = next_scope;
    geocode_queue = [];
    geocode_queue_index = Object.create(null);
    last_pos_geo = get_torre_geocode_cache(next_scope);

    let stored_unit_filter = load_json_storage(
      get_scoped_storage_key(UNIT_FILTER_KEY, next_scope),
      []
    );
    table_pos_f = Array.isArray(stored_unit_filter) ? stored_unit_filter : [];

    let stored_silenced_units = load_json_storage(
      get_scoped_storage_key(SILENCED_UNITS_KEY, next_scope),
      {}
    );
    silenced_units =
      stored_silenced_units &&
      typeof stored_silenced_units === "object" &&
      !Array.isArray(stored_silenced_units)
        ? stored_silenced_units
        : {};

    let stored_saved_views = load_json_storage(
      get_scoped_storage_key(SAVED_VIEWS_KEY, next_scope),
      []
    );
    saved_views = Array.isArray(stored_saved_views) ? stored_saved_views : [];

    let stored_geofence_dwell = load_json_storage(
      get_scoped_storage_key(GEOFENCE_DWELL_KEY, next_scope),
      {}
    );
    geofence_dwell =
      stored_geofence_dwell &&
      typeof stored_geofence_dwell === "object" &&
      !Array.isArray(stored_geofence_dwell)
        ? stored_geofence_dwell
        : {};

    active_view_name =
      window.localStorage.getItem(
        get_scoped_storage_key(ACTIVE_VIEW_KEY, next_scope)
      ) || "";
    search_filter =
      window.localStorage.getItem(
        get_scoped_storage_key(SEARCH_FILTER_KEY, next_scope)
      ) || "";
    quick_filters = load_quick_filters(
      get_scoped_storage_key(QUICK_FILTERS_KEY, next_scope)
    );
    score_config = load_score_config(
      get_scoped_storage_key(SCORE_CONFIG_KEY, next_scope)
    );
    score_config_form = { ...score_config };
    storage_hydrated = true;
  }

  function create_empty_summary() {
    return {
      total: 0,
      moving: 0,
      stopped: 0,
      no_report: 0,
      gps_bad: 0,
      signal_bad: 0,
      geofence: 0,
      high_priority: 0,
      silenced: 0,
    };
  }

  function has_anomaly(item) {
    return (
      is_no_report(item) ||
      is_high_speed(item) ||
      is_gps_bad(item) ||
      is_signal_bad(item) ||
      is_priority_high(item)
    );
  }

  function build_geocode_request_key(lat, lon) {
    return lat + "," + lon;
  }

  function format_reverse_geocode_address(dir_p) {
    if (!dir_p || typeof dir_p.address == "undefined") {
      return null;
    }
    return (
      (typeof dir_p.address.suburb != "undefined" &&
      typeof dir_p.address.road == "undefined"
        ? dir_p.address.suburb + ", "
        : "") +
      (typeof dir_p.address.road != "undefined" ? dir_p.address.road + ", " : "") +
      (typeof dir_p.address.county != "undefined"
        ? dir_p.address.county + ", "
        : "") +
      (typeof dir_p.address.state != "undefined" ? dir_p.address.state : "")
    );
  }

  function queue_geocode(modid, lat, lon, request_key) {
    let request_scope = storage_scope;
    let scoped_request_key = request_scope + "|" + request_key;
    if (
      geocode_queue_index[modid] === scoped_request_key ||
      geocode_inflight_index[modid] === scoped_request_key
    ) {
      return;
    }
    geocode_queue_index[modid] = scoped_request_key;
    geocode_queue.push({
      modid,
      lat,
      lon,
      request_key,
      request_scope,
      scoped_request_key,
    });
    pump_geocode_queue();
  }

  function pump_geocode_queue() {
    if (geocode_pump_timer != null) {
      return;
    }
    geocode_pump_timer = setTimeout(() => {
      geocode_pump_timer = null;
      while (
        geocode_inflight_count < GEOCODE_CONCURRENCY &&
        geocode_queue.length > 0
      ) {
        let next_geocode = geocode_queue.shift();
        if (!next_geocode) {
          continue;
        }
        if (
          geocode_queue_index[next_geocode.modid] !==
          next_geocode.scoped_request_key
        ) {
          continue;
        }
        delete geocode_queue_index[next_geocode.modid];
        geocode_inflight_index[next_geocode.modid] =
          next_geocode.scoped_request_key;
        geocode_inflight_count = geocode_inflight_count + 1;
        fetchJsonSafe(
          EXT_OMNI_GEOC_URL + "/reverse?lat=" +
            next_geocode.lat +
            "&lon=" +
            next_geocode.lon +
            "&format=json&polygon_text=1",
          { fallback: null, logLabel: "torre geocode" }
        )
          .then(function (dir_p) {
            let dir_f = format_reverse_geocode_address(dir_p);
            if (!dir_f || next_geocode.request_scope !== storage_scope) {
              return;
            }
            if (
              typeof last_pos_geo[next_geocode.modid] == "undefined" ||
              last_pos_geo[next_geocode.modid][3] !== next_geocode.request_key
            ) {
              return;
            }
            last_pos_geo[next_geocode.modid][2] = dir_f;
          })
          .finally(function () {
            geocode_inflight_count = geocode_inflight_count - 1;
            if (
              geocode_inflight_index[next_geocode.modid] ===
              next_geocode.scoped_request_key
            ) {
              delete geocode_inflight_index[next_geocode.modid];
            }
            if (geocode_queue.length > 0) {
              pump_geocode_queue();
            }
          });
      }
    }, 0);
  }

  function get_score(modid) {
    return typeof points_pos[modid] == "number" ? points_pos[modid] : 0;
  }

  function get_last_comm_seconds(item) {
    let timestamp = Number(item && item.last_comm);
    if (!Number.isFinite(timestamp) || timestamp <= 0) {
      return null;
    }
    while (timestamp > 100000000000) {
      timestamp = timestamp / 1000;
    }
    return timestamp;
  }

  function get_report_time_label(item) {
    let timestamp = get_last_comm_seconds(item);
    if (timestamp == null) {
      return "-";
    }
    return moment(new Date(timestamp * 1000)).format("DD/MM/YY HH:mm:ss");
  }

  function get_report_age_minutes(item, now_seconds = Date.now() / 1000) {
    let timestamp = get_last_comm_seconds(item);
    return timestamp == null ? null : Math.max(0, (now_seconds - timestamp) / 60);
  }

  function get_report_age_label(item) {
    let age_minutes = get_report_age_minutes(item);
    return age_minutes == null ? "-" : format_minutes(age_minutes);
  }

  function is_no_report(item, now_seconds = Date.now() / 1000) {
    let last_comm = get_last_comm_seconds(item);
    if (last_comm == null) {
      return false;
    }
    return (
      (now_seconds - last_comm > score_config.no_report_minutes_on * 60 &&
        item.ingnition == 1) ||
      (now_seconds - last_comm > score_config.no_report_minutes_off * 60 &&
        item.ingnition == 0)
    );
  }

  function is_report_warning(item, now_seconds = Date.now() / 1000) {
    let last_comm = get_last_comm_seconds(item);
    if (last_comm == null) {
      return false;
    }
    return (
      now_seconds - last_comm < score_config.no_report_minutes_on * 60 &&
      now_seconds - last_comm > 60 * 10
    );
  }

  function is_high_speed(item) {
    return has_numeric_value(item && item.vel) &&
      Number(item.vel) > score_config.high_speed_threshold;
  }

  function is_gps_bad(item) {
    return has_numeric_value(item && item.hdop) && Number(item.hdop) > 1.5;
  }

  function is_signal_bad(item) {
    return has_numeric_value(item && item.rssi) && Number(item.rssi) >= 100;
  }

  function has_numeric_value(value) {
    return value !== null && value !== "" && Number.isFinite(Number(value));
  }

  function get_speed_label(item) {
    return has_numeric_value(item && item.vel) ? item.vel + " Km/hr" : "-";
  }

  function get_ignition_label(item) {
    if (!item || (item.ingnition != 0 && item.ingnition != 1)) {
      return "-";
    }
    return item.ingnition == 1 ? "ON" : "OFF";
  }

  function get_gps_label(item) {
    if (!has_numeric_value(item && item.hdop)) {
      return "-";
    }
    return (Number(item.hdop) > 1.5 ? "Malo" : "OK") + " (" + item.hdop + ")";
  }

  function get_signal_label(item) {
    if (!has_numeric_value(item && item.rssi)) {
      return "-";
    }
    let rssi = Number(item.rssi);
    let status = rssi >= 100 ? "Malo" : rssi > 90 ? "Regular" : "Bueno";
    return status + " (" + item.rssi + ")";
  }

  function is_priority_high(item) {
    return (
      item &&
      !is_unit_silenced(item.modid) &&
      get_score(item.modid) >= Math.ceil(score_config.score_max * 0.6)
    );
  }

  function get_priority_reason_label(modid) {
    let reasons = priority_reasons[modid];
    if (!Array.isArray(reasons) || reasons.length == 0) {
      if (is_unit_silenced(modid)) {
        return "Revisada por " + get_silence_remaining_label(modid);
      }
      return "Sin eventos recientes";
    }
    return reasons.join(" / ");
  }

  function add_priority_reason(modid, reason) {
    if (!Array.isArray(priority_reasons[modid])) {
      priority_reasons[modid] = [];
    }
    if (!priority_reasons[modid].includes(reason)) {
      priority_reasons[modid].push(reason);
    }
    if (priority_reasons[modid].length > 3) {
      priority_reasons[modid] = priority_reasons[modid].slice(-3);
    }
  }

  function clear_priority_reason(modid, reason) {
    if (!Array.isArray(priority_reasons[modid])) {
      return;
    }
    priority_reasons[modid] = priority_reasons[modid].filter(
      (item) => item !== reason
    );
  }

  function matches_search_filter(item) {
    let search = search_filter.trim().toLowerCase();
    if (!search) {
      return true;
    }
    let label = get_unit_label(item.modid).toLowerCase();
    let modid = String(item.modid || "").toLowerCase();
    let zone = String(item.geo_zone_name_ || "").toLowerCase();
    return label.includes(search) || modid.includes(search) || zone.includes(search);
  }

  function matches_quick_filters(item) {
    if (quick_filter_set.size == 0) {
      return true;
    }
    for (let filter of quick_filter_set) {
      if (filter == "no_report" && !is_no_report(item)) return false;
      if (filter == "high_speed" && !is_high_speed(item)) return false;
      if (filter == "gps_bad" && !is_gps_bad(item)) return false;
      if (filter == "signal_bad" && !is_signal_bad(item)) return false;
      if (filter == "geofence" && !item.geo_zone_is_match_) return false;
      if (filter == "ignition_on" && item.ingnition != 1) return false;
      if (filter == "priority" && !is_priority_high(item)) return false;
      if (filter == "anomaly" && !has_anomaly(item)) return false;
      if (filter == "hide_silenced" && is_unit_silenced(item.modid)) return false;
    }
    return true;
  }

  function is_row_visible(item) {
    if (!item || get_last_comm_seconds(item) == null) {
      return false;
    }
    return (
      table_pos_filter_set.has(get_unit_label(item.modid)) &&
      matches_search_filter(item) &&
      matches_quick_filters(item)
    );
  }

  function build_summary(rows) {
    let summary = create_empty_summary();
    let now_seconds = Date.now() / 1000;
    for (let item of rows) {
      summary.total = summary.total + 1;
      if (has_numeric_value(item.vel) && Number(item.vel) > 0) {
        summary.moving = summary.moving + 1;
      }
      if (has_numeric_value(item.vel) && Number(item.vel) == 0) {
        summary.stopped = summary.stopped + 1;
      }
      if (is_no_report(item, now_seconds)) summary.no_report = summary.no_report + 1;
      if (is_gps_bad(item)) summary.gps_bad = summary.gps_bad + 1;
      if (is_signal_bad(item)) summary.signal_bad = summary.signal_bad + 1;
      if (item.geo_zone_is_match_) summary.geofence = summary.geofence + 1;
      if (is_priority_high(item)) summary.high_priority = summary.high_priority + 1;
      if (is_unit_silenced(item.modid)) summary.silenced = summary.silenced + 1;
    }
    return summary;
  }

  function toggle_quick_filter(filter_id) {
    if (quick_filter_set.has(filter_id)) {
      quick_filters = quick_filters.filter((item) => item !== filter_id);
    } else {
      quick_filters = [...quick_filters, filter_id];
    }
  }

  function clear_torre_filters() {
    search_filter = "";
    quick_filters = [];
    active_view_name = "";
  }

  function create_view_snapshot(name) {
    return {
      name,
      search: search_filter,
      filters: [...quick_filters],
    };
  }

  function apply_view(view) {
    if (!view) {
      return;
    }
    search_filter = typeof view.search == "string" ? view.search : "";
    quick_filters = Array.isArray(view.filters) ? [...view.filters] : [];
    active_view_name = view.name || "";
  }

  function save_current_view() {
    let saved_name = "Personal";
    let next_view = create_view_snapshot(saved_name);
    saved_views = [
      ...saved_views.filter((view) => view.name !== saved_name),
      next_view,
    ];
    active_view_name = saved_name;
  }

  function delete_saved_view(name) {
    saved_views = saved_views.filter((view) => view.name !== name);
    if (active_view_name == name) {
      active_view_name = "";
    }
  }

  function is_column_visible() {
    return true;
  }

  function visible_column_count() {
    return 2 + column_options.length;
  }

  function toggle_detail(modid) {
    expanded_modid = expanded_modid === modid ? null : modid;
  }

  function format_detail_value(value, fallback = "-") {
    if (typeof value == "undefined" || value === null || value === "") {
      return fallback;
    }
    if (Array.isArray(value) || typeof value == "object") {
      try {
        return JSON.stringify(value);
      } catch (error) {
        return fallback;
      }
    }
    return value;
  }

  function format_minutes(minutes) {
    minutes = Math.max(0, parseInt(minutes, 10) || 0);
    if (minutes < 60) {
      return minutes + "min";
    }
    if (minutes >= 1440) {
      let days = Math.floor(minutes / 1440);
      let rest_hours = Math.floor((minutes % 1440) / 60);
      return days + "d" + (rest_hours > 0 ? " " + rest_hours + "h" : "");
    }
    let hours = Math.floor(minutes / 60);
    let rest = minutes % 60;
    return hours + "h" + (rest > 0 ? " " + rest + "min" : "");
  }

  function update_geofence_dwell(modid, match, now_ms = Date.now()) {
    let match_id = Array.isArray(match) ? match[2] : "";
    let match_name = Array.isArray(match) ? match[0] : "";
    if (!match_id) {
      if (typeof geofence_dwell[modid] != "undefined") {
        delete geofence_dwell[modid];
        geofence_dwell = { ...geofence_dwell };
      }
      return null;
    }
    let current = geofence_dwell[modid];
    if (!current || current.id !== match_id) {
      current = { id: match_id, name: match_name, entered_at: now_ms };
      geofence_dwell = { ...geofence_dwell, [modid]: current };
    } else if (current.name !== match_name) {
      current = { ...current, name: match_name };
      geofence_dwell = { ...geofence_dwell, [modid]: current };
    }
    return current;
  }

  function get_geofence_dwell_label(item) {
    let dwell = geofence_dwell[item.modid];
    if (!item.geo_zone_is_match_ || !dwell || !dwell.entered_at) {
      return "-";
    }
    return format_minutes((Date.now() - dwell.entered_at) / 60000);
  }

  function prune_silenced_units(now_ms = Date.now()) {
    let changed = false;
    let next = { ...silenced_units };
    for (let modid in next) {
      if (!next[modid] || next[modid].until <= now_ms) {
        delete next[modid];
        changed = true;
      }
    }
    if (changed) {
      silenced_units = next;
    }
  }

  function is_unit_silenced(modid) {
    let silence = silenced_units[modid];
    return silence && silence.until > Date.now();
  }

  function get_silence_remaining_label(modid) {
    let silence = silenced_units[modid];
    if (!silence || silence.until <= Date.now()) {
      return "-";
    }
    return format_minutes((silence.until - Date.now()) / 60000);
  }

  function silence_unit(item, minutes) {
    silenced_units = {
      ...silenced_units,
      [item.modid]: {
        until: Date.now() + minutes * 60000,
        label: get_unit_label(item.modid),
      },
    };
    points_pos = { ...points_pos, [item.modid]: 0 };
    priority_reasons = { ...priority_reasons, [item.modid]: [] };
    delete loop_msg[item.modid];
    table_pos_ = [...table_pos_];
    update_marquee(false, true);
    set_action_feedback(item.modid, "Revisada por " + format_minutes(minutes));
  }

  function unsilence_unit(item) {
    let next = { ...silenced_units };
    delete next[item.modid];
    silenced_units = next;
    table_pos_ = [...table_pos_];
    set_action_feedback(item.modid, "Revisión removida");
  }

  function normalize_id_list(value) {
    if (Array.isArray(value)) {
      return value.flatMap((entry) => normalize_id_list(entry));
    }
    if (typeof value == "string") {
      return value
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry !== "");
    }
    if (value == null || value === false) {
      return [];
    }
    return [String(value)];
  }

  function build_travel_index(travel_list) {
    let index = Object.create(null);
    if (!Array.isArray(travel_list)) {
      return index;
    }

    for (let travel of travel_list) {
      if (!travel || typeof travel !== "object") {
        continue;
      }
      let modids = normalize_id_list([travel.id, travel.id_add]);
      let indexed_modids = new Set();
      for (let modid of modids) {
        modid = String(modid);
        if (!modid || indexed_modids.has(modid)) {
          continue;
        }
        indexed_modids.add(modid);
        if (!Array.isArray(index[modid])) {
          index[modid] = [];
        }
        index[modid].push(travel);
      }
    }
    return index;
  }

  function get_unit_travel(item) {
    if (!item || typeof item.modid == "undefined") {
      return null;
    }
    let candidates = travel_by_modid[String(item.modid)];
    if (!Array.isArray(candidates) || candidates.length == 0) {
      return null;
    }
    let active = candidates.find((travel) => travel.step > 0);
    if (active) {
      return active;
    }
    return candidates[0];
  }

  function get_driver_label(driver_id) {
    if (!driver_id) {
      return "-";
    }
    return $drivers && $drivers[driver_id] && $drivers[driver_id].name
      ? $drivers[driver_id].name
      : driver_id;
  }

  function get_unit_type_label(modid) {
    let config = $unit_config && $unit_config[modid] ? $unit_config[modid] : null;
    let type_id = config && typeof config.type != "undefined" ? config.type : "";
    if (type_id === "") {
      return "-";
    }
    let type = $unit_types && $unit_types[type_id] ? $unit_types[type_id] : null;
    if (type && typeof type == "object") {
      return type.name || type.label || type.type || type_id;
    }
    return type || type_id;
  }

  function get_travel_status_label(travel) {
    if (!travel) {
      return "Sin viaje";
    }
    if (travel.step > 0) {
      return "En viaje, paso " + travel.step;
    }
    if (travel.step == 0) {
      return "Programado";
    }
    return "Con viaje";
  }

  function resolve_travel_destination(destination) {
    let destination_id =
      destination && typeof destination == "object"
        ? destination.name || destination.id || destination.label
        : destination;
    if (!destination_id) {
      return "-";
    }
    let geofence = $geos_class && $geos_class[destination_id];
    if (Array.isArray(geofence) && geofence[0]) {
      return geofence[0];
    }
    let polygon = $poli && $poli[destination_id];
    if (Array.isArray(polygon) && polygon[1]) {
      return polygon[1];
    }
    return destination_id;
  }

  function resolve_travel_route(route) {
    let route_id =
      route && typeof route == "object"
        ? route.name || route.id || route.label
        : route;
    if (!route_id) {
      return "-";
    }
    let route_label = $route_list_d && $route_list_d[route_id];
    if (route_label && typeof route_label == "object") {
      return route_label.name || route_label.label || route_id;
    }
    return route_label || route_id;
  }

  function get_travel_detail(travel, field) {
    if (!travel) {
      return "-";
    }
    let travel_record =
      travel.uuid && $travels && $travels[travel.uuid]
        ? $travels[travel.uuid]
        : $travels && $travels[travel.id]
        ? $travels[travel.id]
        : null;
    let monitor_crtl = travel_record && travel_record.monitor_crtl
      ? travel_record.monitor_crtl
      : {};
    if (field == "status") return get_travel_status_label(travel);
    if (field == "driver") {
      return get_driver_label(travel.oper || travel.driver || monitor_crtl.driver);
    }
    if (field == "destination") {
      return resolve_travel_destination(
        travel.dest || travel.destino || monitor_crtl.destino
      );
    }
    if (field == "route") {
      return resolve_travel_route(
        travel.route || travel.ruta || monitor_crtl.ruta
      );
    }
    if (field == "start") {
      return travel.date_ini
        ? moment(new Date(travel.date_ini * 1000)).format("DD/MM/YY HH:mm")
        : "-";
    }
    if (field == "uuid") return travel.uuid || travel.id || "-";
    return "-";
  }

  function update_marquee(decrement_time, clear_existing = false) {
    let message_output = "";
    for (let modid in loop_msg) {
      for (let message_key in loop_msg[modid]) {
        let message = loop_msg[modid][message_key];
        if (decrement_time) {
          message.time = message.time - 1;
        }
        if (
          message.time > 0 &&
          !is_unit_silenced(modid) &&
          table_pos_filter_set.has(message.nick)
        ) {
          message_output = message_output + message.msg + " | ";
        }
      }
    }
    if (clear_existing && marquee != null) {
      marquee.clear();
    }
    if (control != null && message_output != "") {
      control.update([() => message_output]);
    } else if (control != null) {
      control.update([() => " Torre de control | "]);
    }
  }

  function normalize_monitor_name(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function set_action_feedback(modid, message) {
    action_feedback = { ...action_feedback, [modid]: message };
    if (action_feedback_timer != null) {
      clearTimeout(action_feedback_timer);
    }
    action_feedback_timer = setTimeout(() => {
      action_feedback = {};
      action_feedback_timer = null;
    }, 1800);
  }

  function open_unit_in_monitor(item) {
    menu.set(6);
    cc_monitor.set([
      {
        type: "select_unit",
        name: normalize_monitor_name(get_unit_label(item.modid)),
      },
    ]);
    set_action_feedback(item.modid, "Unidad enviada a Monitor");
  }

  function open_unit_recorridos(item) {
    torre_unit_navigation.set({
      target: "recorridos",
      modid: String(item.modid),
      requestedAt: Date.now(),
    });
    menu.set(2);
    set_action_feedback(item.modid, "Abriendo Recorridos");
  }

  function open_unit_travels(item) {
    torre_unit_navigation.set({
      target: "viajes",
      modid: String(item.modid),
      requestedAt: Date.now(),
    });
    menu.set(4);
    set_action_feedback(item.modid, "Abriendo Viajes");
  }

  function open_unit_map(item) {
    if (typeof window === "undefined") {
      return;
    }
    window.open(
      "https://www.google.com/maps/search/?api=1&query=" +
        encodeURIComponent(item.lat + "," + item.lon),
      "_blank",
      "noopener,noreferrer"
    );
  }

  function fallback_copy_text(text) {
    let text_area = document.createElement("textarea");
    text_area.value = text;
    text_area.setAttribute("readonly", "readonly");
    text_area.style.position = "fixed";
    text_area.style.left = "-9999px";
    document.body.appendChild(text_area);
    text_area.select();
    document.execCommand("copy");
    document.body.removeChild(text_area);
  }

  async function copy_action_text(item, text, message) {
    if (typeof window === "undefined") {
      return;
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        fallback_copy_text(text);
      }
      set_action_feedback(item.modid, message);
    } catch (error) {
      fallback_copy_text(text);
      set_action_feedback(item.modid, message);
    }
  }

  function copy_unit_label(item) {
    copy_action_text(item, get_unit_label(item.modid), "Económico copiado");
  }

  function copy_unit_coordinates(item) {
    copy_action_text(
      item,
      item.lat + "," + item.lon,
      "Coordenadas copiadas"
    );
  }

  function rebuild_ranked_table(table_pos_live) {
    let previous_index_by_modid = Object.create(null);
    let live_order_by_modid = Object.create(null);
    let next_rows = [];
    let live_order = 0;

    for (let index = 0; index < table_pos_p.length; index++) {
      if (
        typeof table_pos_p[index] != "undefined" &&
        typeof table_pos_p[index].modid != "undefined"
      ) {
        previous_index_by_modid[table_pos_p[index].modid] = index;
      }
    }

    for (let modid in table_pos_live) {
      live_order_by_modid[modid] = live_order;
      live_order = live_order + 1;
      next_rows.push(table_pos_live[modid]);
    }

    next_rows.sort((a, b) => {
      let score_diff =
        (is_unit_silenced(b.modid) ? 0 : get_score(b.modid)) -
        (is_unit_silenced(a.modid) ? 0 : get_score(a.modid));
      if (score_diff !== 0) {
        return score_diff;
      }
      let previous_a = previous_index_by_modid[a.modid];
      let previous_b = previous_index_by_modid[b.modid];
      if (typeof previous_a == "number" && typeof previous_b == "number") {
        return previous_a - previous_b;
      }
      if (typeof previous_a == "number") {
        return -1;
      }
      if (typeof previous_b == "number") {
        return 1;
      }
      return live_order_by_modid[a.modid] - live_order_by_modid[b.modid];
    });

    for (let index = 0; index < next_rows.length; index++) {
      let previous_index = previous_index_by_modid[next_rows[index].modid];
      if (typeof previous_index != "number") {
        next_rows[index].level_c = 0;
      } else if (previous_index > index) {
        next_rows[index].level_c = 1;
      } else if (previous_index < index) {
        next_rows[index].level_c = -1;
      } else {
        next_rows[index].level_c = 0;
      }
    }

    table_pos_p = next_rows;
    table_pos_ = [...next_rows];
  }

  function get_unit_label(modid) {
    return typeof $nicks_list[modid] != "undefined" ? $nicks_list[modid] : modid;
  }

  function lista() {
    let table_pos_live = Object.create(null);
    let no_report_seconds_on = score_config.no_report_minutes_on * 60;
    let no_report_seconds_off = score_config.no_report_minutes_off * 60;
    let now_seconds = Date.now() / 1000;
    let now_ms = Date.now();

    prune_silenced_units(now_ms);

    for (let x in $live) {
      if (typeof $live[x] == "undefined") {
        continue;
      }
      let modid = $live[x].modid;
      let geocode_request_key = build_geocode_request_key($live[x].lat, $live[x].lon);
      let update_now = false;
      if (typeof last_pos_geo[modid] == "undefined") {
        last_pos_geo[modid] = [
          $live[x].lat,
          $live[x].lon,
          $live[x].lat + ", " + $live[x].lon,
          geocode_request_key,
        ];
        update_now = true;
      } else {
        if (typeof last_pos_geo[modid][2] == "undefined") {
          last_pos_geo[modid][2] = $live[x].lat + ", " + $live[x].lon;
        }
        if (typeof last_pos_geo[modid][3] == "undefined") {
          last_pos_geo[modid][3] = build_geocode_request_key(
            last_pos_geo[modid][0],
            last_pos_geo[modid][1]
          );
        }
        if (
          get_km(
            last_pos_geo[modid][0],
            last_pos_geo[modid][1],
            $live[x].lat,
            $live[x].lon
          ) > 0.1
        ) {
          last_pos_geo[modid] = [
            $live[x].lat,
            $live[x].lon,
            last_pos_geo[modid][2],
            geocode_request_key,
          ];
          update_now = true;
        }
      }
      let position_label =
        typeof last_pos_geo[modid][2] == "undefined"
          ? $live[x].lat + ", " + $live[x].lon
          : last_pos_geo[modid][2];
      let geo_match = searchGeofence($live[x].lat, $live[x].lon, {
        geosMap: $geos_map,
        poli: $poli,
        geos: $geos,
        geosClass: $geos_class,
        classifiedOnly: true,
      });
      let geo_zone_is_match =
        Array.isArray(geo_match) &&
        typeof geo_match[2] != "undefined" &&
        geo_match[2] !== "";
      let geo_dwell = update_geofence_dwell(modid, geo_match, now_ms);
      let travel = get_unit_travel({ modid });
      table_pos_live[modid] = {
        ...$live[x],
        geo_name_: position_label,
        geo_zone_name_: geo_zone_is_match ? geo_match[0] : position_label,
        geo_zone_is_match_: geo_zone_is_match,
        geo_zone_type_: geo_zone_is_match ? geo_match[1] : "",
        geo_zone_id_: geo_zone_is_match ? geo_match[2] : "",
        geo_zone_entered_at_: geo_dwell ? geo_dwell.entered_at : null,
        travel_status_: get_travel_status_label(travel),
        travel_driver_: get_travel_detail(travel, "driver"),
        travel_destination_: get_travel_detail(travel, "destination"),
        travel_route_: get_travel_detail(travel, "route"),
        travel_start_: get_travel_detail(travel, "start"),
        unit_type_: get_unit_type_label(modid),
        level_c: 0,
      };
      if (update_now) {
        last_pos_geo[modid][3] = geocode_request_key;
        queue_geocode(modid, $live[x].lat, $live[x].lon, geocode_request_key);
      }
    }

    for (let x in live_st) {
      if (typeof $live[x] == "undefined") {
        delete loop_msg[x];
        delete points_pos[x];
        continue;
      }
      if (typeof loop_msg[x] == "undefined") {
        loop_msg[x] = {};
      }
      if (typeof points_pos[x] == "undefined") {
        points_pos[x] = 0;
      }
      let ec1 = get_unit_label(live_st[x].modid);

      if (is_unit_silenced(x)) {
        points_pos[x] = 0;
        priority_reasons[x] = [];
        continue;
      }
      if (live_st[x] != $live[x]) {
        points_pos[x] = points_pos[x] + score_config.weight_any_change;
        add_priority_reason(x, "cambio general");
      }
      if (live_st[x].ingnition != $live[x].ingnition) {
        points_pos[x] = points_pos[x] + score_config.weight_ignition_change;
        add_priority_reason(x, "ignición");
        loop_msg[x]["ing"] = {
          msg:
            ec1 +
            " ignicion " +
            ($live[x].ingnition == 1 ? "encendida" : "apagada"),
          time: 60,
          nick: ec1,
        };
      }
      if (live_st[x].vel == 0 && $live[x].vel > 0) {
        points_pos[x] = points_pos[x] + score_config.weight_movement_start;
        add_priority_reason(x, "inició movimiento");
        loop_msg[x]["mov"] = {
          msg: ec1 + " inicia movimiento ",
          time: 60,
          nick: ec1,
        };
      }
      if (live_st[x].vel > 0 && $live[x].vel == 0) {
        points_pos[x] = points_pos[x] + score_config.weight_movement_stop;
        add_priority_reason(x, "se detuvo");
        loop_msg[x]["mov"] = {
          msg: ec1 + " sin movimiento ",
          time: 60,
          nick: ec1,
        };
      }
      if ($live[x].vel > score_config.high_speed_threshold) {
        points_pos[x] = points_pos[x] + score_config.weight_high_speed;
        add_priority_reason(x, "velocidad alta");
        loop_msg[x]["mov"] = {
          msg: ec1 + " velocidad alta " + $live[x].vel + " Km/hr",
          time: 60,
          nick: ec1,
        };
      }
      let last_comm_seconds = get_last_comm_seconds(live_st[x]);
      if (
        last_comm_seconds != null &&
        ((now_seconds - last_comm_seconds > no_report_seconds_on &&
          live_st[x].ingnition == 1) ||
          (now_seconds - last_comm_seconds > no_report_seconds_off &&
            live_st[x].ingnition == 0))
      ) {
        points_pos[x] = points_pos[x] + score_config.weight_no_report;
        add_priority_reason(x, "sin reporte");
        loop_msg[x]["time"] = {
          msg:
            ec1 +
            " sin reportar por " +
            format_minutes((now_seconds - last_comm_seconds) / 60),
          time: 60,
          nick: ec1,
        };
      }
      if (points_pos[x] > 0) points_pos[x] = points_pos[x] - score_config.score_decay;
      if (points_pos[x] < 0) points_pos[x] = 0;
      if (points_pos[x] > score_config.score_max) {
        points_pos[x] = score_config.score_max;
      }
      if (points_pos[x] == 0) {
        priority_reasons[x] = [];
      }
      if (!is_high_speed($live[x])) {
        clear_priority_reason(x, "velocidad alta");
      }
      if (!is_no_report($live[x], now_seconds)) {
        clear_priority_reason(x, "sin reporte");
      }
    }

    live_st = { ...$live };
    rebuild_ranked_table(table_pos_live);

    update_marquee(true);
  }

  function get_km(lat1, lon1, lat2, lon2) {
    return getKm(lat1, lon1, lat2, lon2);
  }

  function sort_units_for_filter_modal() {
    units_list_p = [...$units_list];
    units_list_p.sort(units_order);
  }

  function open_filter_modal() {
    sort_units_for_filter_modal();
    filtro_modal = true;
  }

  function open_score_modal() {
    score_config_form = { ...score_config };
    score_modal = true;
  }

  function save_score_modal() {
    score_config = normalize_score_config(score_config_form);
    score_modal = false;
  }

  function reset_score_modal() {
    score_config_form = { ...default_score_config };
  }

  $: if ($group && String($group).trim() !== storage_scope) {
    hydrate_torre_storage($group);
  }

  $: {
    travel_by_modid = build_travel_index($travel_crtl);
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(UNIT_FILTER_KEY, storage_scope),
      JSON.stringify(table_pos_f)
    );
  }

  $: {
    table_pos_filter_set = new Set(table_pos_f);
  }

  $: if (storage_hydrated && storage_scope) {
    quick_filter_set = new Set(quick_filters);
    window.localStorage.setItem(
      get_scoped_storage_key(QUICK_FILTERS_KEY, storage_scope),
      JSON.stringify(quick_filters)
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(SEARCH_FILTER_KEY, storage_scope),
      search_filter
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(SILENCED_UNITS_KEY, storage_scope),
      JSON.stringify(silenced_units)
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(SAVED_VIEWS_KEY, storage_scope),
      JSON.stringify(saved_views)
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(ACTIVE_VIEW_KEY, storage_scope),
      active_view_name
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(GEOFENCE_DWELL_KEY, storage_scope),
      JSON.stringify(geofence_dwell)
    );
  }

  $: if (storage_hydrated && storage_scope) {
    window.localStorage.setItem(
      get_scoped_storage_key(SCORE_CONFIG_KEY, storage_scope),
      JSON.stringify(score_config)
    );
  }

  $: {
    filtered_table_pos_ = table_pos_.filter(is_row_visible);
    torre_summary = build_summary(filtered_table_pos_);
  }

  $: if (filtro_modal) {
    $units_list;
    $nicks_list;
    sort_units_for_filter_modal();
  }

  function units_order(a, b) {
    if ($nicks_list[b] < $nicks_list[a]) {
      return 1;
    } else {
      return -1;
    }
    return 0;
  }
</script>

{#if filtro_modal}
  <div
    class="modal fade {filtro_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {filtro_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">directions</i> Lista de
            unidades
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-0">
          <ul class="list-group mx-2">
            {#each units_list_p as item}
              <li class="list-group-item">
                <input
                  type="checkbox"
                  value={get_unit_label(item)}
                  bind:group={table_pos_f}
                />
                {get_unit_label(item)}
              </li>
            {/each}
          </ul>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-end">
            <div>
              <button
                on:click={() => {
                  filtro_modal = false;
                }}
                class="btn btn-danger big"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if score_modal}
  <div
    class="modal fade {score_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle-score"
    aria-hidden="true"
    style="padding-right: 17px; display: {score_modal
      ? 'block'
      : 'none'}; z-index:1039;"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle-score">
            <i class="material-icons bblue md-2">tune</i> Configuración de
            reglas
            <strong />
          </h5>
        </div>
        <div class="modal-body h-100 p-3 w-100">
          <p class="mb-3">
            Ajusta los valores de priorización para el acomodo de unidades.
          </p>
          <div class="alert alert-light border score-help">
            <h6 class="mb-2">
              <i class="material-icons bblue md-1">help_outline</i> Cómo se
              calculan los puntos
            </h6>
            <p class="mb-2">
              Los puntos sirven para decidir qué unidad aparece más arriba.
            </p>
            <ul class="mb-2">
              <li>Si pasa algo importante, la unidad <strong>suma puntos</strong>.</li>
              <li>Entre más puntos tenga, más prioridad tiene en la lista.</li>
              <li>En cada actualización, los puntos <strong>bajan solos</strong>.</li>
            </ul>
            <p class="mb-2">
              Ejemplos de eventos: cambio de ignición, inicio/fin de movimiento,
              velocidad alta o mucho tiempo sin reportar.
            </p>
            <p class="mb-0">
              Tú ajustas:
              <strong>Pesos</strong> = cuántos puntos suma cada evento.
              <strong>Umbrales</strong> = desde qué valor cuenta como evento.
            </p>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <h6 class="mb-3">
                <i class="material-icons bblue md-1">tune</i> Pesos
              </h6>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Cambio general</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_any_change}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Cambio de ignición</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_ignition_change}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Inicio de movimiento</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_movement_start}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Fin de movimiento</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_movement_stop}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Velocidad alta</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_high_speed}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label">Sin reporte</label>
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.weight_no_report}
                />
                <label class="form-check-label">Pts</label>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <h6 class="mb-3">
                <i class="material-icons bblue md-1">straighten</i> Umbrales
              </h6>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Velocidad alta</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.high_speed_threshold}
                />
                <label class="form-check-label">km/h</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Sin reporte (ignición ON)</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.no_report_minutes_on}
                />
                <label class="form-check-label">Min</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Sin reporte (ignición OFF)</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.no_report_minutes_off}
                />
                <label class="form-check-label">Min</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Decaimiento por ciclo</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="0"
                  bind:value={score_config_form.score_decay}
                />
                <label class="form-check-label">Pts</label>
              </div>
              <div class="form-group d-flex align-items-center">
                <label class="form-check-label mr-2 score-label"
                  >Puntaje máximo</label
                >
                <input
                  class="form-control mr-2 score-input"
                  type="number"
                  min="1"
                  bind:value={score_config_form.score_max}
                />
                <label class="form-check-label">Pts</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="display: block;">
          <div class="d-flex justify-content-between">
            <button
              on:click={reset_score_modal}
              class="btn btn-secondary big"
              type="button"
            >
              <i class="material-icons md-85">refresh</i>
              Valores iniciales
            </button>
            <div>
              <button
                on:click={() => {
                  score_modal = false;
                }}
                class="btn btn-danger big mr-2"
                type="button"
              >
                <i class="material-icons md-85">clear</i>
                Cerrar
              </button>
              <button
                on:click={save_score_modal}
                class="btn btn-success big"
                type="button"
              >
                <i class="material-icons md-85">save</i>
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

<main role="main" class="torre-page mdc-top-app-bar--dense-fixed-adjust mdc-typography">
  <section class="torre-shell">
    <header class="torre-hero">
      <div class="torre-title-block">
        <span class="torre-eyebrow">Operación en vivo</span>
        <h1>Torre de control</h1>
        <div class="torre-hero-meta">
          <span>{torre_summary.total} visibles</span>
          <span>{torre_summary.high_priority} prioridad alta</span>
          <span>{torre_summary.no_report} sin reporte</span>
        </div>
      </div>
      <div class="torre-primary-actions">
        <button
          type="button"
          class="torre-command-button is-primary"
          on:click={open_filter_modal}
        >
          <i class="material-icons md-85">tune</i>
          Unidades
        </button>
        <button
          type="button"
          class="torre-command-button"
          on:click={open_score_modal}
        >
          <i class="material-icons md-85">rule</i>
          Prioridad
        </button>
        <button
          type="button"
          class="torre-command-button is-clear"
          title="Limpiar filtros"
          on:click={clear_torre_filters}
          disabled={quick_filters.length == 0 && search_filter.trim() == ""}
        >
          <i class="material-icons md-85">filter_alt_off</i>
          Limpiar
        </button>
      </div>
    </header>

    <section class="torre-control-deck">
      <div class="torre-search-card">
        <div class="torre-search-label">Buscar</div>
        <div class="torre-search-box">
          <i class="material-icons md-85">search</i>
          <input
            class="torre-search-input"
            type="search"
            placeholder="Económico, ID o geocerca"
            bind:value={search_filter}
          />
        </div>
      </div>

      <div class="torre-control-card is-wide is-filters">
        <div class="torre-control-header">
          <span>Vistas</span>
          <button type="button" class="torre-text-button" on:click={save_current_view}>
            Guardar
          </button>
        </div>
        <div class="torre-segment-row">
          {#each view_profiles as view}
            <button
              type="button"
              class="torre-segment"
              class:is-active={active_view_name == view.name}
              on:click={() => apply_view(view)}
            >{view.name}</button>
          {/each}
          {#each saved_views as view}
            <button
              type="button"
              class="torre-segment"
              class:is-active={active_view_name == view.name}
              on:click={() => apply_view(view)}
            >{view.name}</button>
          {/each}
          {#if saved_views.length > 0}
            <button
              type="button"
              class="torre-segment is-subtle"
              on:click={() => delete_saved_view("Personal")}
            >Borrar personal</button>
          {/if}
        </div>
      </div>

      <div class="torre-control-card is-wide">
        <div class="torre-control-header">
          <span>Filtros</span>
          <span>{quick_filters.length} activos</span>
        </div>
        <div class="torre-chip-row">
          {#each quick_filter_options as filter}
            <button
              type="button"
              class="torre-chip"
              class:is-active={quick_filter_set.has(filter.id)}
              on:click={() => toggle_quick_filter(filter.id)}
            >{filter.label}</button>
          {/each}
        </div>
      </div>

    </section>

    <section class="torre-summary-grid">
      <div class="torre-summary-item">
        <span>Total</span><strong>{torre_summary.total}</strong>
      </div>
      <div class="torre-summary-item is-ok">
        <span>Movimiento</span><strong>{torre_summary.moving}</strong>
      </div>
      <div class="torre-summary-item is-muted">
        <span>Detenidas</span><strong>{torre_summary.stopped}</strong>
      </div>
      <div class="torre-summary-item" class:is-danger={torre_summary.no_report > 0}>
        <span>Sin reporte</span><strong>{torre_summary.no_report}</strong>
      </div>
      <div class="torre-summary-item" class:is-warning={torre_summary.gps_bad > 0}>
        <span>GPS malo</span><strong>{torre_summary.gps_bad}</strong>
      </div>
      <div class="torre-summary-item" class:is-warning={torre_summary.signal_bad > 0}>
        <span>Señal mala</span><strong>{torre_summary.signal_bad}</strong>
      </div>
      <div class="torre-summary-item is-zone">
        <span>Geocerca</span><strong>{torre_summary.geofence}</strong>
      </div>
      <div class="torre-summary-item" class:is-danger={torre_summary.high_priority > 0}>
        <span>Prioridad alta</span><strong>{torre_summary.high_priority}</strong>
      </div>
      <div class="torre-summary-item is-muted">
        <span>Revisadas</span><strong>{torre_summary.silenced}</strong>
      </div>
    </section>

    <section class="torre-table-panel">
      <div class="tableFixHead">
              <table class="table table-striped table-bordered">
                <thead class="thead-light">
                  <tr>
                    <!--<th scope="col">Nivel</th>-->
                    <th scope="col" class="torre-col-toggle" title="Detalle" />
                    <th scope="col" class="torre-col-unit" title="Económico">Económico</th>
                    {#if is_column_visible("priority")}
                      <th scope="col" class="torre-col-priority" title="Prioridad">Prioridad</th>
                    {/if}
                    {#if is_column_visible("speed")}
                      <th scope="col" class="torre-col-speed" title="Velocidad">Velocidad</th>
                    {/if}
                    {#if is_column_visible("ignition")}
                      <th scope="col" class="torre-col-ignition" title="Ignición">Ignición</th>
                    {/if}
                    {#if is_column_visible("report_time")}
                      <th scope="col" class="torre-col-report-time" title="Último reporte">Último reporte</th>
                    {/if}
                    {#if is_column_visible("report_age")}
                      <th scope="col" class="torre-col-report-age" title="Sin reportar">Sin reportar</th>
                    {/if}
                    {#if is_column_visible("gps")}
                      <th scope="col" class="torre-col-gps" title="GPS/HDOP">GPS/HDOP</th>
                    {/if}
                    {#if is_column_visible("signal")}
                      <th scope="col" class="torre-col-signal" title="Señal/Red">Señal/Red</th>
                    {/if}
                    {#if is_column_visible("geofence")}
                      <th scope="col" class="torre-col-geofence" title="Geocerca/Zona">Geocerca/Zona</th>
                    {/if}
                    {#if is_column_visible("travel")}
                      <th scope="col" class="torre-col-travel" title="Viaje">Viaje</th>
                    {/if}
                  </tr>
                </thead>
                <tbody>
                  {#each filtered_table_pos_ as item (item.modid)}
                        <tr>
                          <!--<td>{points_pos[item.modid]}</td>-->
                          <td class="torre-col-toggle"
                            ><button
                              type="button"
                              class="btn btn-link torre-detail-toggle p-0"
                              on:click={() => toggle_detail(item.modid)}
                            >
                              <i
                                style="font-weight: bold;"
                                class="material-icons md-24"
                                class:green={item.level_c > 0}
                                class:red={item.level_c < 0}
                                class:gray={item.level_c == 0}
                                >{expanded_modid === item.modid
                                  ? "expand_less"
                                  : item.level_c > 0
                                  ? "arrow_upward"
                                  : item.level_c < 0
                                  ? "arrow_downward"
                                  : "remove_circle_outline"}</i
                              >
                            </button></td
                          >
                          <th scope="row" class="torre-col-unit"
                            >{get_unit_label(item.modid)}</th
                          >
                          {#if is_column_visible("priority")}
                          <td class="torre-col-priority"
                            class:table-danger={is_priority_high(item)}
                            class:table-warning={!is_priority_high(item) && get_score(item.modid) > 0}
                            class:table-secondary={get_score(item.modid) == 0 || is_unit_silenced(item.modid)}
                          >
                            <strong>{get_score(item.modid)}</strong>
                            <small class="priority-reason">
                              {get_priority_reason_label(item.modid)}
                            </small>
                          </td>
                          {/if}
                          {#if is_column_visible("speed")}
                          <td class="torre-col-speed"
                            class:table-success={has_numeric_value(item.vel) && item.vel <=
                              score_config.high_speed_threshold &&
                              item.vel != 0}
                            class:table-secondary={has_numeric_value(item.vel) && item.vel == 0}
                            class:table-danger={has_numeric_value(item.vel) && item.vel >
                              score_config.high_speed_threshold}
                            >{get_speed_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("ignition")}
                          <td class="torre-col-ignition"
                            class:table-success={item.ingnition == 1}
                            class:table-secondary={item.ingnition == 0}
                            >{get_ignition_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("report_time")}
                          <td class="torre-col-report-time"
                            class:table-danger={is_no_report(item)}
                            class:table-warning={is_report_warning(item)}
                            >{get_report_time_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("report_age")}
                          <td class="torre-col-report-age"
                            class:table-danger={is_no_report(item)}
                            class:table-warning={is_report_warning(item)}
                            >{get_report_age_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("gps")}
                          <td class="torre-col-gps"
                            class:bg-danger={has_numeric_value(item.hdop) && item.hdop > 1.5}
                            class:table-success={has_numeric_value(item.hdop) && item.hdop <= 1.5}
                            >{get_gps_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("signal")}
                          <td class="torre-col-signal"
                            class:bg-danger={has_numeric_value(item.rssi) && item.rssi >= 100}
                            class:table-success={has_numeric_value(item.rssi) && item.rssi <= 90}
                            class:bg-warning={has_numeric_value(item.rssi) && item.rssi > 90 && item.rssi < 100}
                            >{get_signal_label(item)}</td
                          >
                          {/if}
                          {#if is_column_visible("geofence")}
                          <td class="torre-col-geofence" class:table-success={item.geo_zone_is_match_}
                            >{item.geo_zone_name_}
                            {#if item.geo_zone_is_match_}
                              <small class="priority-reason">{get_geofence_dwell_label(item)}</small>
                            {/if}</td
                          >
                          {/if}
                          {#if is_column_visible("travel")}
                          <td class="torre-col-travel" class:table-info={item.travel_status_ != "Sin viaje"}>
                            {item.travel_status_}
                            <small class="priority-reason">
                              {format_detail_value(item.travel_driver_)}
                            </small>
                          </td>
                          {/if}
                        </tr>
                        {#if expanded_modid === item.modid}
                          <tr class="torre-detail-row">
                            <td colspan={visible_column_count()}>
                              <div class="torre-detail-actions">
                                <div class="torre-action-group is-navigation">
                                  <button
                                    type="button"
                                    class="torre-action-button is-primary"
                                    on:click={() => open_unit_in_monitor(item)}
                                  >
                                    <i class="material-icons md-85">monitor</i>
                                    Monitor
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button"
                                    on:click={() => open_unit_map(item)}
                                  >
                                    <i class="material-icons md-85">map</i>
                                    Mapa
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button"
                                    on:click={() => open_unit_recorridos(item)}
                                  >
                                    <i class="material-icons md-85">timeline</i>
                                    Recorridos
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button"
                                    on:click={() => open_unit_travels(item)}
                                  >
                                    <i class="material-icons md-85">local_shipping</i>
                                    Viajes
                                  </button>
                                </div>
                                <div class="torre-action-group">
                                  <button
                                    type="button"
                                    class="torre-action-button is-quiet"
                                    on:click={() => copy_unit_coordinates(item)}
                                  >
                                    <i class="material-icons md-85">content_copy</i>
                                    Coordenadas
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button is-quiet"
                                    on:click={() => copy_unit_label(item)}
                                  >
                                    <i class="material-icons md-85">badge</i>
                                    Económico
                                  </button>
                                </div>
                                <div class="torre-action-group is-review">
                                  <button
                                    type="button"
                                    class="torre-action-button is-success"
                                    on:click={() => silence_unit(item, 10)}
                                  >
                                    <i class="material-icons md-85">done</i>
                                    10 min
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button is-success"
                                    on:click={() => silence_unit(item, 30)}
                                  >
                                    <i class="material-icons md-85">done_all</i>
                                    30 min
                                  </button>
                                  <button
                                    type="button"
                                    class="torre-action-button is-success"
                                    on:click={() => silence_unit(item, 60)}
                                  >
                                    <i class="material-icons md-85">schedule</i>
                                    60 min
                                  </button>
                                  {#if is_unit_silenced(item.modid)}
                                    <button
                                      type="button"
                                      class="torre-action-button is-danger"
                                      on:click={() => unsilence_unit(item)}
                                    >
                                      <i class="material-icons md-85">undo</i>
                                      Quitar revisión
                                    </button>
                                  {/if}
                                </div>
                                {#if action_feedback[item.modid]}
                                  <span class="torre-action-feedback">
                                    {action_feedback[item.modid]}
                                  </span>
                                {/if}
                              </div>
                              <div class="torre-detail-grid">
                                <div><span>ID</span><strong>{format_detail_value(item.modid)}</strong></div>
                                <div><span>Lat/Lon</span><strong>{format_detail_value(item.lat)}, {format_detail_value(item.lon)}</strong></div>
                                <div><span>Dirección</span><strong>{format_detail_value(item.geo_name_)}</strong></div>
                                <div><span>Geocerca</span><strong>{item.geo_zone_is_match_ ? item.geo_zone_name_ : "Sin geocerca clasificada"}</strong></div>
                                <div><span>Tipo geocerca</span><strong>{format_detail_value(item.geo_zone_type_)}</strong></div>
                                <div><span>Tiempo en geocerca</span><strong>{get_geofence_dwell_label(item)}</strong></div>
                                <div><span>Estado viaje</span><strong>{format_detail_value(item.travel_status_)}</strong></div>
                                <div><span>Operador</span><strong>{format_detail_value(item.travel_driver_)}</strong></div>
                                <div><span>Destino</span><strong>{format_detail_value(item.travel_destination_)}</strong></div>
                                <div><span>Ruta</span><strong>{format_detail_value(item.travel_route_)}</strong></div>
                                <div><span>Inicio viaje</span><strong>{format_detail_value(item.travel_start_)}</strong></div>
                                <div><span>Tipo unidad</span><strong>{format_detail_value(item.unit_type_)}</strong></div>
                                <div><span>Revisión</span><strong>{is_unit_silenced(item.modid) ? get_silence_remaining_label(item.modid) : "Sin revisión"}</strong></div>
                                <div><span>HDOP</span><strong>{format_detail_value(item.hdop)}</strong></div>
                                <div><span>RSSI</span><strong>{format_detail_value(item.rssi)}</strong></div>
                                <div><span>Red</span><strong>{format_detail_value(item.network)}</strong></div>
                                <div><span>Rumbo</span><strong>{format_detail_value(item.heading)}</strong></div>
                                <div><span>VIN</span><strong>{format_detail_value(item.vin)}</strong></div>
                                <div><span>Voltaje</span><strong>{format_detail_value(item.vout)}</strong></div>
                                <div><span>Evento</span><strong>{format_detail_value(item.event_code)}</strong></div>
                                <div><span>Entradas</span><strong>{format_detail_value(item.inputs)}</strong></div>
                                <div><span>Salidas 0</span><strong>{format_detail_value(item.outputs_0)}</strong></div>
                                <div><span>Salidas 1</span><strong>{format_detail_value(item.outputs_1)}</strong></div>
                              </div>
                            </td>
                          </tr>
                        {/if}
                  {/each}
                </tbody>
              </table>
      </div>
    </section>
    <div id="marquee" />
  </section>
</main>

<style>
  .btn {
    vertical-align: initial;
    padding: 2px 8px;
    font-size: 0.78rem;
  }
  .torre-page {
    --torre-top-bar-height: 48px;
    box-sizing: border-box;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    height: 100vh;
    height: 100dvh;
    padding: calc(var(--torre-top-bar-height) + 12px) 14px 44px;
    background: #eef2f5;
    color: #26313d;
    overflow: hidden;
  }
  .torre-shell {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    min-height: 0;
    height: 100%;
    gap: 10px;
  }
  .torre-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    width: 100%;
    min-width: 0;
    padding: 14px 16px;
    border: 1px solid #cfd9e2;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
  }
  .torre-title-block {
    min-width: 0;
  }
  .torre-eyebrow {
    display: block;
    color: #607080;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
  }
  .torre-title-block h1 {
    margin: 0;
    color: #1f2a35;
    font-size: 1.42rem;
    font-weight: 700;
    line-height: 1.2;
  }
  .torre-hero-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 5px;
    color: #5f6d7a;
    font-size: 0.75rem;
  }
  .torre-hero-meta span {
    padding-right: 8px;
    border-right: 1px solid #d9e0e6;
  }
  .torre-hero-meta span:last-child {
    border-right: 0;
  }
  .torre-primary-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .torre-command-button,
  .torre-text-button,
  .torre-action-button,
  .torre-chip,
  .torre-segment {
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease,
      color 0.15s ease, box-shadow 0.15s ease;
  }
  .torre-command-button {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    min-height: 32px;
    padding: 5px 11px;
    border-color: #c5d0da;
    background: #f7fafc;
    color: #33404d;
    font-size: 0.78rem;
    font-weight: 700;
  }
  .torre-command-button.is-primary {
    border-color: #0d7d88;
    background: #0f8995;
    color: #ffffff;
  }
  .torre-command-button.is-clear {
    border-color: #d5dde5;
    background: #ffffff;
    color: #536171;
  }
  .torre-command-button:hover,
  .torre-action-button:hover,
  .torre-chip:hover,
  .torre-segment:hover,
  .torre-text-button:hover {
    box-shadow: 0 2px 8px rgba(31, 45, 61, 0.12);
  }
  .torre-command-button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
    box-shadow: none;
  }
  .torre-control-deck {
    flex: 0 0 auto;
    display: grid;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.15fr) minmax(0, 2.6fr);
    gap: 10px;
  }
  .torre-search-card,
  .torre-control-card {
    min-width: 0;
    padding: 10px;
    border: 1px solid #d1dbe4;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 3px 12px rgba(31, 45, 61, 0.05);
  }
  .torre-search-label,
  .torre-control-header {
    color: #586777;
    font-size: 0.72rem;
    font-weight: 700;
  }
  .torre-search-label,
  .torre-control-header {
    margin-bottom: 7px;
  }
  .torre-control-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .torre-control-header span:last-child {
    color: #7b8794;
    font-size: 0.68rem;
  }
  .torre-search-box {
    display: flex;
    align-items: center;
    gap: 7px;
    min-height: 34px;
    padding: 0 9px;
    border: 1px solid #bfcbd6;
    border-radius: 6px;
    background: #f9fbfc;
  }
  .torre-search-box:focus-within {
    border-color: #0f8995;
    box-shadow: 0 0 0 3px rgba(15, 137, 149, 0.12);
  }
  .torre-search-input {
    width: 100%;
    min-width: 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: #26313d;
    font-size: 0.82rem;
  }
  .torre-text-button {
    padding: 2px 8px;
    border-color: #c0d5d9;
    background: #eef9fa;
    color: #0f6871;
    font-size: 0.7rem;
    font-weight: 700;
  }
  .torre-segment-row,
  .torre-chip-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  .torre-segment {
    min-height: 26px;
    padding: 4px 9px;
    border-color: #ced7df;
    background: #f7f9fb;
    color: #485664;
    font-size: 0.74rem;
    font-weight: 650;
  }
  .torre-segment.is-active {
    border-color: #235d68;
    background: #235d68;
    color: #ffffff;
  }
  .torre-segment.is-subtle {
    border-style: dashed;
    color: #687684;
  }
  .torre-chip {
    min-height: 25px;
    min-width: max-content;
    padding: 3px 8px;
    border-color: #c8d2dc;
    background: #ffffff;
    color: #42505e;
    font-size: 0.73rem;
    line-height: 1.2;
  }
  .torre-chip.is-active {
    border-color: #0f8995;
    background: #dff5f7;
    color: #0b5d66;
    font-weight: 700;
  }
  .torre-summary-grid {
    flex: 0 0 auto;
    display: grid;
    width: 100%;
    min-width: 0;
    grid-template-columns: repeat(9, minmax(92px, 1fr));
    gap: 8px;
  }
  .torre-summary-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
    padding: 8px 10px;
    border: 1px solid #ccd7e0;
    border-left: 4px solid #7c8a97;
    border-radius: 7px;
    background: #ffffff;
    color: #343f4a;
    box-shadow: 0 2px 10px rgba(31, 45, 61, 0.04);
  }
  .torre-summary-item span {
    color: #667484;
    font-size: 0.7rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .torre-summary-item strong {
    color: #1e2b36;
    font-size: 1rem;
    font-weight: 800;
  }
  .torre-summary-item.is-ok {
    border-left-color: #2c9b6f;
    background: #f2fbf6;
  }
  .torre-summary-item.is-muted {
    border-left-color: #94a1ad;
    background: #f7f9fa;
  }
  .torre-summary-item.is-warning {
    border-left-color: #c58a18;
    background: #fff8e8;
  }
  .torre-summary-item.is-danger {
    border-left-color: #c84855;
    background: #fff1f2;
  }
  .torre-summary-item.is-zone {
    border-left-color: #168b95;
    background: #eefafa;
  }
  .torre-table-panel {
    flex: 1;
    width: 100%;
    min-width: 0;
    min-height: 220px;
    overflow: hidden;
    border: 1px solid #cbd6df;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(31, 45, 61, 0.07);
  }
  .torre-table-panel table {
    min-width: max-content;
    margin-bottom: 0;
    color: #2f3b47;
    font-size: 0.78rem;
  }
  .torre-table-panel .table td,
  .torre-table-panel .table th {
    vertical-align: middle;
    border-color: #e0e7ee;
    padding: 0.42rem 0.5rem;
  }
  .torre-table-panel tbody tr:hover {
    background: #f4fafb;
  }
  .torre-table-panel tbody th[scope="row"] {
    color: #24313d;
    font-weight: 800;
  }
  .tableFixHead {
    overflow: auto;
    height: 100%;
  }
  .tableFixHead thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    border-top: 0;
    background: #f4f7f9;
    color: #536171;
    font-size: 0.72rem;
    font-weight: 800;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .torre-col-toggle {
    min-width: 42px;
    width: 42px;
    text-align: center;
  }
  .torre-col-unit {
    min-width: 150px;
    max-width: 220px;
  }
  .torre-col-priority {
    min-width: 128px;
  }
  .torre-col-speed,
  .torre-col-ignition,
  .torre-col-report-age,
  .torre-col-gps,
  .torre-col-signal {
    min-width: 112px;
  }
  .torre-col-report-time {
    min-width: 150px;
  }
  .torre-col-geofence,
  .torre-col-travel {
    min-width: 170px;
    max-width: 240px;
  }
  .torre-table-panel tbody .torre-col-unit,
  .torre-table-panel tbody .torre-col-geofence,
  .torre-table-panel tbody .torre-col-travel {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .torre-detail-toggle {
    color: #536171;
    text-decoration: none;
  }
  .priority-reason {
    display: block;
    max-width: 135px;
    color: #5b6875;
    font-size: 0.68rem;
    line-height: 1.15;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .torre-detail-row td {
    padding: 0;
    background: #f5f8fa;
  }
  .torre-detail-actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    padding: 10px 12px 0 14px;
    border-left: 4px solid #168b95;
  }
  .torre-action-group {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    padding-right: 7px;
    margin-right: 3px;
    border-right: 1px solid #d7e0e7;
  }
  .torre-action-group:last-of-type {
    border-right: 0;
  }
  .torre-action-button {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: 27px;
    padding: 4px 8px;
    border-color: #c3d0da;
    background: #ffffff;
    color: #374554;
    font-size: 0.72rem;
    font-weight: 700;
  }
  .torre-action-button.is-primary {
    border-color: #0f8995;
    background: #0f8995;
    color: #ffffff;
  }
  .torre-action-button.is-quiet {
    border-color: #d5dde5;
    background: #f8fafb;
    color: #536171;
  }
  .torre-action-button.is-success {
    border-color: #92c9ad;
    background: #effaf4;
    color: #1f714d;
  }
  .torre-action-button.is-danger {
    border-color: #e0a3aa;
    background: #fff3f4;
    color: #9f2f3b;
  }
  .torre-action-feedback {
    color: #0f6848;
    font-size: 0.74rem;
    font-weight: 600;
  }
  .torre-detail-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 6px;
    padding: 8px 12px 12px 14px;
    border-left: 4px solid #168b95;
  }
  .torre-detail-grid div {
    min-width: 0;
    padding: 5px 7px;
    border: 1px solid #d9e2e9;
    border-radius: 6px;
    background: #ffffff;
  }
  .torre-detail-grid span {
    display: block;
    color: #68717b;
    font-size: 0.68rem;
    line-height: 1.1;
  }
  .torre-detail-grid strong {
    display: block;
    color: #2f363d;
    font-size: 0.78rem;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .score-label {
    min-width: 52%;
    margin-bottom: 0;
  }
  .score-input {
    width: 100px;
    max-width: 100px;
  }
  .modal-content {
    border: 0;
    border-radius: 8px;
    box-shadow: 0 24px 80px rgba(15, 23, 42, 0.28);
  }
  .modal-header {
    border-bottom-color: #e3e9ef;
    background: #f8fafc;
  }
  .modal-footer {
    border-top-color: #e3e9ef;
    background: #f8fafc;
  }
  #marquee {
    position: fixed;
    overflow: hidden;
    margin: 0;
    padding: 5px 0;
    font-size: 18px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #343a40;
    color: #ffffff;
    font-family: Verdana, Geneva, sans-serif;
  }
  @media (max-width: 1200px) {
    .torre-control-deck {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
    .torre-control-card.is-filters {
      grid-column: 1 / -1;
    }
    .torre-summary-grid {
      grid-template-columns: repeat(3, minmax(120px, 1fr));
    }
  }
  @media (max-width: 720px), (max-height: 600px) {
    .torre-page {
      height: auto;
      min-height: 100vh;
      min-height: 100dvh;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .torre-shell {
      height: auto;
      min-height: calc(100vh - 104px);
      min-height: calc(100dvh - 104px);
    }
    .torre-table-panel {
      flex: 0 0 auto;
      height: 55vh;
      height: 55dvh;
      min-height: 320px;
    }
  }
  @media (max-width: 720px) {
    .torre-page {
      padding: calc(var(--torre-top-bar-height) + 8px) 8px 44px;
    }
    .torre-hero {
      align-items: stretch;
      flex-direction: column;
    }
    .torre-primary-actions {
      justify-content: flex-start;
    }
    .torre-control-deck {
      grid-template-columns: 1fr;
    }
    .torre-summary-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 6px;
    }
    .torre-summary-item {
      padding: 7px 8px;
    }
    .torre-action-group {
      width: 100%;
      border-right: 0;
      border-bottom: 1px solid #d7e0e7;
      padding-bottom: 6px;
    }
  }
  @font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url(../css/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");
  }
  .material-icons {
    font-family: "Material Icons";
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  .material-icons.md-1 {
    font-size: 1rem;
  }
  .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }
  .material-icons.md-85 {
    font-size: 1.3rem;
  }
  .material-icons.md-90 {
    font-size: 1.5rem;
  }
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }
  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
  .material-icons.orange {
    color: #ff7043;
  }
  .material-icons.bblue {
    color: #26a69a;
  }
  .material-icons.green {
    color: rgb(24, 179, 45);
  }
  .material-icons.yei {
    color: #ff9800;
  }
  .material-icons.golden {
    color: #856404;
  }
  .material-icons.gray {
    color: #525a63;
  }
  .material-icons.red {
    color: #df1616;
  }
  i {
    vertical-align: middle;
    padding-bottom: 3px;
  }
  span.blue {
    color: rgb(17, 33, 255);
  }
</style>
